import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CKEDITORCONFIG } from '../ckeditor-config';
import { HttpService } from '../service/http.service';
import { Language } from '../language';
import { ToastMessageService } from '../toast-message.service';
import { ContactRequestPdfTemplate } from '../contact-request-pdf-template';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';

@Component({
  selector: 'app-create-wp-contact-request-pdf-template',
  templateUrl: './create-wp-contact-request-pdf-template.component.html',
  styleUrls: ['./create-wp-contact-request-pdf-template.component.css']
})
export class CreateWpContactRequestPdfTemplateComponent implements OnInit {

  templateForm!: FormGroup;
  sendingForm = false;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private toastService: ToastMessageService,
    private pdfTemplateService: PdfDocumentTemplateService
  ) { }

  ngOnInit() {
    this.templateForm = this.builder.group({
      name: ["", Validators.required],
      body: ["", Validators.required]
    });
  }

  sendForm() {
    if (this.templateForm.invalid) {
      this.toastService.addError("Error", "Please complete all informations");
      return;
    }

    this.sendingForm = true;
    this.httpService.postContactRequestPdfTemplate(
      new ContactRequestPdfTemplate(
        this.templateForm.value.name.trim(),
        this.templateForm.value.body.trim(),
        this.pdfTemplateService.selectedLanguage
      )
    ).subscribe({
      next: () => {
        this.toastService.addSuccess("Success", "Template created");
        this.templateForm.get("name")?.reset();
        this.templateForm.get("body")?.reset();
        this.sendingForm = false;
      }, 
      error: error => {
        this.toastService.addError("Error", error.message);
        this.sendingForm = false;
      } 
    });
  }
  
}
